"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSessionData = processSessionData;
exports.getSessionData = getSessionData;
exports.setSessionData = setSessionData;
exports.clearSessionData = clearSessionData;
function processSessionData(SESSION_STORAGE) {
    var _a;
    try {
        const now = new Date().getTime();
        const sessionData = getSessionData(SESSION_STORAGE);
        if (sessionData) {
            const parsedSessionData = JSON.parse(sessionData);
            const expiry = (_a = parsedSessionData === null || parsedSessionData === void 0 ? void 0 : parsedSessionData.expiry) !== null && _a !== void 0 ? _a : 0;
            if (now > expiry) {
                sessionStorage.removeItem(SESSION_STORAGE.SESSION_KEY_NAME);
            }
            return parsedSessionData;
        }
        return null;
    }
    catch (error) {
        console.error('Error in processSessionData :', error);
    }
}
function getSessionData(SESSION_STORAGE) {
    return sessionStorage.getItem(SESSION_STORAGE.SESSION_KEY_NAME);
}
function setSessionData(SESSION_STORAGE, data, action, trackingData) {
    try {
        // If a new entry is added with an existing key, it will replace the old entry.
        const now = new Date().getTime() +
            SESSION_STORAGE.EXPIRY_TIME_OFFSET * 60 * 1000;
        const sessionData = {
            watchData: data,
            expiry: now,
            watchAction: action,
            trackingData,
        };
        sessionStorage.setItem(SESSION_STORAGE.SESSION_KEY_NAME, JSON.stringify(sessionData));
    }
    catch (error) {
        console.error('An error occurred while setting session data:', error);
    }
}
function clearSessionData(SESSION_STORAGE) {
    sessionStorage.removeItem(SESSION_STORAGE.SESSION_KEY_NAME);
}
